
import { FC } from "react";
import { Routes } from "react-router-dom";
import { Route } from "react-router-dom";
import { LandingPage } from "./LandingPage";
import { AccessGuard } from "./AccessGuard";

export const RxdCoursePage: FC = () => {
	return <Routes>
		<Route index element={<AccessGuard>
			<LandingPage />
		</AccessGuard>} />
	</Routes>
};